import React from 'react';
import { Checkbox } from 'baseui/checkbox';
import { ISmartProps } from './types';
import { CheckboxDescription } from './styles';
import { overrides as customOverrides } from './overrides';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { useStyletron } from '../../Themes';
import { mergeOverrides } from 'baseui';
import * as meta from '../../meta-data.json';

type EpoType = Omit<ISmartProps, 'css'>;
export const View = React.forwardRef((props: EpoType, ref: any) => {
	const { overrides, checkmarkType, children, size, ...rest } = props;
	const HTMLAttrs = getHTMLAttributes(props);
	const [, theme] = useStyletron();

	return (
		<div className={props.className}
			data-epo={`epo-checkbox-${meta.version}`}
			{...{ part: `epo-checkbox-${meta.version}` }} >
			<Checkbox
				{...rest}
				ref={ref}
				children={children}
				checkmarkType="default"
				overrides={
					overrides
						? mergeOverrides(
							customOverrides(props, HTMLAttrs.ariaProps, HTMLAttrs.dataProps, theme),
							overrides as any,
						)
						: customOverrides(props, HTMLAttrs.ariaProps, HTMLAttrs.dataProps, theme)
				}
			/>
			{
				props.description && (
					<CheckboxDescription
						data-epo={`epo-checkbox-${meta.version}`}
						part={`epo-checkbox-${meta.version}`}
						disabled={props.disabled ? 'disabled' : undefined}
						labelplacement={props.labelPlacement}
						size={props.size}
					>
						{props.description}
					</CheckboxDescription>
				)
			}
		</div >
	);
});
